/* ClassyPod: limit product gallery to 6 images per selected variant.
   Rule: the selected variant's featured image first, then fill with the
   remaining images (original order) up to 6 total. Everything else is hidden
   in the main gallery + thumbnails. Liquid keeps the same compact media set
   in the zoom modal, including every image needed for variant switching. */
(function () {
  'use strict';
  var MAX = 6;

  function mediaIdOf(attr) {
    if (!attr) return null;
    var i = attr.lastIndexOf('-');
    return i === -1 ? attr : attr.slice(i + 1);
  }

  function getVariantsFor(picker) {
    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getVariantGalleryMap(gallery) {
    var script = gallery.querySelector('script[data-cp-variant-gallery-map]');
    if (!script) return null;
    try {
      var map = JSON.parse(script.textContent);
      return map && typeof map === 'object' ? map : null;
    } catch (e) {
      return null;
    }
  }

  function currentVariantId(sectionId) {
    var input = document.querySelector(
      '#product-form-' + sectionId + ' input[name="id"], form[id^="product-form-' + sectionId + '"] input[name="id"]'
    );
    return input ? String(input.value) : null;
  }

  function primePreferredMedia(slide) {
    if (!slide) return;
    var images = slide.querySelectorAll('img');
    Array.prototype.forEach.call(images, function (image) {
      image.loading = 'eager';
      image.setAttribute('fetchpriority', 'high');
      // decode() also prompts browsers to fetch an image that was initially
      // below the native lazy-loading threshold before this variant was picked.
      if (!image.complete && typeof image.decode === 'function') {
        image.decode().catch(function () {});
      }
    });
  }

  function applyToGallery(gallery, featuredMediaId, selectedVariantId, initial) {
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('li.product__media-item[data-media-id]')
    );
    if (!slides.length) return null;

    // Current media IDs. Dawn may prepend a selected variant slide later; the
    // original fallback is stored separately below so that reorder is harmless.
    var ids = slides.map(function (li) {
      return mediaIdOf(li.getAttribute('data-media-id'));
    });

    // Some imported products have variants without featured_media. Dawn still
    // renders a sensible primary slide for those products, so remember that
    // server-selected slide and use it whenever the selected variant has no
    // media of its own. Keeping the value on the gallery also makes switching
    // from a media-backed variant back to a media-less variant deterministic.
    var fallbackMediaId = gallery.getAttribute('data-cp-fallback-media-id');
    if (!fallbackMediaId) {
      var initialActive = gallery.querySelector(
        'li.product__media-item.is-active[data-media-id]'
      );
      var fallbackSlide = initialActive || slides[0];
      fallbackMediaId = mediaIdOf(fallbackSlide.getAttribute('data-media-id'));
      if (fallbackMediaId) {
        gallery.setAttribute('data-cp-fallback-media-id', fallbackMediaId);
      }
    }

    var allowed = [];
    var initialMediaId = initial && gallery.getAttribute('data-cp-initial-media-id');
    if (initialMediaId && ids.indexOf(initialMediaId) !== -1) {
      allowed.push(initialMediaId);
    }
    var variantGalleryMap = getVariantGalleryMap(gallery);
    var assignedMediaIds = [];
    Object.keys(variantGalleryMap || {}).forEach(function (variantId) {
      var media = variantGalleryMap[variantId];
      if (Array.isArray(media)) assignedMediaIds = assignedMediaIds.concat(media.map(String));
    });
    var mappedMedia =
      variantGalleryMap && selectedVariantId
        ? variantGalleryMap[String(selectedVariantId)]
        : null;

    if (Array.isArray(mappedMedia)) {
      mappedMedia.forEach(function (mediaId) {
        var id = String(mediaId);
        if (allowed.length < MAX && ids.indexOf(id) !== -1 && allowed.indexOf(id) === -1) {
          allowed.push(id);
        }
      });
    }
    if (!allowed.length) {
      if (featuredMediaId && ids.indexOf(String(featuredMediaId)) !== -1) {
        allowed.push(String(featuredMediaId));
      } else if (fallbackMediaId && ids.indexOf(String(fallbackMediaId)) !== -1) {
        allowed.push(String(fallbackMediaId));
      }
    }
    for (var k = 0; k < ids.length && allowed.length < MAX; k++) {
      if (slides[k].classList.contains('product__media-item--variant')) continue;
      if (assignedMediaIds.indexOf(ids[k]) !== -1) continue;
      if (allowed.indexOf(ids[k]) === -1) allowed.push(ids[k]);
    }

    slides.forEach(function (li) {
      var id = mediaIdOf(li.getAttribute('data-media-id'));
      Array.prototype.forEach.call(li.querySelectorAll('img[fetchpriority="high"]'), function (image) {
        image.removeAttribute('fetchpriority');
      });
      li.style.removeProperty('display');
      li.dataset.cpGalleryVisible = String(allowed.indexOf(id) !== -1);
      li.classList.toggle('product__media-item--single', allowed.length === 1);
    });

    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    Array.prototype.forEach.call(thumbs, function (li) {
      var target =
        li.getAttribute('data-target') ||
        (li.querySelector('[data-target]') &&
          li.querySelector('[data-target]').getAttribute('data-target'));
      var id = mediaIdOf(target);
      li.style.removeProperty('display');
      li.dataset.cpGalleryVisible = String(allowed.indexOf(id) !== -1);
    });

    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (thumbnails) {
      thumbnails.hidden = allowed.length < 2;
      thumbnails.classList.toggle('thumbnail-slider--no-slide', allowed.length <= 3);
      Array.prototype.forEach.call(thumbnails.querySelectorAll('.slider-button'), function (button) {
        button.classList.toggle('small-hide', allowed.length <= 3);
        button.classList.toggle('medium-hide', allowed.length <= 4);
        button.classList.toggle('large-up-hide', allowed.length <= 4);
      });
      if (!thumbnails.hidden && typeof thumbnails.resetPages === 'function') thumbnails.resetPages();
    }
    if (viewer) {
      var controls = viewer.querySelector('.slider-buttons');
      if (controls) {
        controls.classList.toggle('small-hide', allowed.length < 2 || !!(thumbnails && !thumbnails.classList.contains('small-hide')));
      }
      if (typeof viewer.resetPages === 'function') viewer.resetPages();
      var total = viewer.querySelector('.slider-counter--total');
      if (total) total.textContent = allowed.length;
    }

    // The desktop thumbnail layout only displays `.is-active`. If the previous
    // active slide was hidden while changing variants, activate the preferred
    // visible slide through Dawn's gallery API so the main image cannot blank.
    var activeSlide = gallery.querySelector(
      'li.product__media-item.is-active[data-media-id]'
    );
    var activeId = activeSlide
      ? mediaIdOf(activeSlide.getAttribute('data-media-id'))
      : null;
    if (allowed.length && activeId !== allowed[0]) {
      var preferredSlide = slides.filter(function (li) {
        return mediaIdOf(li.getAttribute('data-media-id')) === allowed[0];
      })[0];
      if (preferredSlide) {
        primePreferredMedia(preferredSlide);
        var targetMediaId = preferredSlide.getAttribute('data-media-id');
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(targetMediaId, false);
        } else {
          slides.forEach(function (li) {
            li.classList.remove('is-active');
          });
          preferredSlide.classList.add('is-active');
        }
      }
    } else if (allowed.length) {
      primePreferredMedia(activeSlide);
    }

    if (thumbnails && typeof gallery.setActiveThumbnail === 'function' && allowed.length) {
      gallery.setActiveThumbnail(thumbnails.querySelector('[data-target$="-' + allowed[0] + '"]'));
    }
    var selectedSlide = gallery.querySelector('li.product__media-item.is-active[data-media-id]');
    if (viewer && viewer.slider && selectedSlide) {
      viewer.slider.scrollTo({ left: selectedSlide.offsetLeft, behavior: 'instant' });
    }
    return allowed;
  }

  function applySection(sectionId, variants, initial) {
    var featured = null;
    var selectedVariantId = currentVariantId(sectionId);
    if (variants) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === selectedVariantId) {
          if (variants[i].featured_media) featured = variants[i].featured_media.id;
          break;
        }
      }
    }
    var galleries = document.querySelectorAll('media-gallery[id^="MediaGallery-' + sectionId + '"]');
    var allowedMediaIds = null;
    Array.prototype.forEach.call(galleries, function (g) {
      var galleryMediaIds = applyToGallery(g, featured, selectedVariantId, initial);
      if (!allowedMediaIds && galleryMediaIds) allowedMediaIds = galleryMediaIds;
    });

    // Dawn prepends media-backed variants in the modal, but a variant without
    // featured media needs the deterministic fallback moved back to the front.
    // Otherwise its modal image retains the variant-only CSS hidden state.
    if (allowedMediaIds && allowedMediaIds.length) {
      var preferredMediaId = allowedMediaIds[0];
      var modalContent = document.querySelector(
        '#ProductModal-' + sectionId + ' .product-media-modal__content'
      );
      if (modalContent) {
        Array.prototype.forEach.call(modalContent.children, function (media) {
          if (!media.hasAttribute('data-media-id')) return;
          media.style.removeProperty('display');
          media.dataset.cpGalleryVisible = String(allowedMediaIds.indexOf(media.getAttribute('data-media-id')) !== -1);
        });
      }
      var modalMedia = modalContent
        ? modalContent.querySelector('[data-media-id="' + preferredMediaId + '"]')
        : null;
      if (modalMedia && modalContent.firstElementChild !== modalMedia) {
        modalContent.prepend(modalMedia);
      }
    }
  }

  function init() {
    var pickers = document.querySelectorAll('variant-radios[data-section], variant-selects[data-section]');
    var covered = {};

    Array.prototype.forEach.call(pickers, function (picker) {
      var sectionId = picker.getAttribute('data-section');
      var variants = getVariantsFor(picker);
      covered[sectionId] = true;

      var run = function () {
        applySection(sectionId, variants);
      };
      picker.addEventListener('change', function () {
        // let the theme update the hidden variant input first
        setTimeout(run, 80);
        setTimeout(run, 350);
      });
      applySection(sectionId, variants, true);
    });

    // Galleries without a variant picker (single-variant products): first 6 only
    Array.prototype.forEach.call(document.querySelectorAll('media-gallery[id^="MediaGallery-"]'), function (g) {
      var id = g.id.replace('MediaGallery-', '');
      var owned = Object.keys(covered).some(function (s) {
        return id.indexOf(s) === 0;
      });
      if (!owned) applySection(id, null, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
